import React from "react";
import FontAwesomeIcon from "@streeteasy/design-system/deprecated/Icons/FontAwesomeIcon";
import TextLink from "@streeteasy/design-system/deprecated/TextLink";
import { object, shape, string } from "prop-types";

import {
  ConfirmationWrapper,
  ContactConfirmationLinkWrapper,
  ModalHeading,
  ModalIconWrapper,
  ModalText,
  ModalTitle
} from "../../../../styled";

const SSOUserConfirmation = props => (
  <ConfirmationWrapper>
    <ModalIconWrapper>
      <FontAwesomeIcon color="primary" fontSize="33px" iconClass="checkmark" />
    </ModalIconWrapper>
    <ModalHeading scenario={props.scenario}>
      <ModalTitle scenario={props.scenario} type="primarySm">
        You shared this {props.data.sharedType}
      </ModalTitle>
    </ModalHeading>
    <ModalText>{props.data.confirmationText}</ModalText>
    <ContactConfirmationLinkWrapper>
      <TextLink href={props.data.ssoUrl} theme="primaryTouchedBoldUnderline">
        sign in to access your account
      </TextLink>
    </ContactConfirmationLinkWrapper>
  </ConfirmationWrapper>
);

SSOUserConfirmation.propTypes = {
  data: shape({
    confirmationText: object.isRequired,
    email: string.isRequired,
    sharedType: string.isRequired,
    ssoUrl: string.isRequired
  }).isRequired,
  scenario: string.isRequired
};

export default SSOUserConfirmation;
